module.exports = __webpack_public_path__ + "../resources/img/ic_re_arc_shine_glass_img.408c7a5c.svg";